<template>
  <div class="life_costs-pages-prestore-list content-container" id="life_costs-pages-prestore-list">
    <div class="container-scroll">
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>开具发票</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 end-->
      <!--search部分-->
      <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
          <h1 class="holder-title">搜索条件</h1>
          <a-form class="cabinvue-search-form">
              <a-row :gutter="24">
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>项目：</span>
                          </div>
                          <div class="item-control">
                              <a-select v-model="condition.communityId" @change="communityChange" placeholder="请选择项目">
                                <a-select-option v-for="item in pageData.custList" :key="item.communityId" :value="item.communityId">{{item.communityName}}</a-select-option>
                              </a-select>
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>账单月份：</span>
                          </div>
                          <div class="item-control">
                              <a-date-picker
                                placeholder="请选中账单月份"
                                style="width:100%;"
                                v-model="pageData.billingCycle"
                                @change="billingCycleChange"
                                format="YYYY-MM-DD"
                              />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>合同号：</span>
                          </div>
                          <div class="item-control">
                              <a-input v-model="condition.contractCode" placeholder="请输入合同号" />
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <hr />
              <div class="form-option-area">
                  <a-button icon="search" class="space-margin-right" type="primary" :loading="tableObj.tableLoading"
                      @click.stop="search">查询</a-button>
                  <a-button icon="reload" class="space-margin-right btn-outline" @click.stop="resetEvt">重置</a-button>
              </div>
          </a-form>
      </section>
      <!--search部分 end-->
      <!--表格部分-->
      <section class="layout-table layout-pad-full layout-margin-bottom back-white">
        <div class="table-option-area space-margin-bottom">
          <a-button icon="plus" type="primary" @click.stop="drawerOpen" :loading="tableObj.tableLoding" :disabled="!hasSelected">开票</a-button>
        </div>
        <a-table 
          :row-selection="{ selectedRowKeys: tableObj.selectedRowKeys, onChange: onSelectChange }"
          size="middle" 
          class="J_compensation_list_table" 
          :columns="tableObj.columns"
          :data-source="tableObj.list" 
          :pagination="false"
          :scroll="tableObj.scroll"
          :loading="tableObj.tableLoding">
        </a-table>
      </section>
      <!--表格部分 end-->

      <a-drawer
        title="开票信息"
        :visible="drawer.visible"
        :placement="drawer.placement"
        :height="drawer.height"
        :body-style="{ paddingBottom: '80px' }"
        @close="drawerClose"
      >
        <a-form :form="drawerForm">
          <a-row :gutter="16">
            <a-col :span="12" v-show="false">
              <a-form-item label="id">
                <a-input
                  v-decorator="[
                    'id',
                    {
                      rules: [{ required: false, message: '请输入id', whitespace: true }],
                      initialValue: drawer.form.id
                    }
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入id"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-show="false">
              <a-form-item label="客户号">
                <a-input
                  v-decorator="[
                    'custId',
                    {
                      rules: [{ required: false, message: '请输入客户号', whitespace: true }],
                      initialValue: drawer.form.custId
                    }
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入客户号"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-show="false">
              <a-form-item label="merId">
                <a-input
                  v-decorator="[
                    'merId',
                    {
                      rules: [{ required: false, message: '请输入merId', whitespace: true }],
                      initialValue: drawer.form.custId
                    }
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入merId"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="项目">
                <a-select
                  v-decorator="[
                    'communityId',
                    {
                      rules: [{ required: false, message: '请输入项目', whitespace: true }],
                      initialValue: drawer.form.communityId
                    }
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入项目"
                >
                  <a-select-option v-for="item in pageData.custList" :key="item.communityId" :value="item.communityId">{{item.communityName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="客户名">
                <a-input
                  v-decorator="[
                    'custName',
                    {
                      rules: [{ required: false, message: '请输入客户名', whitespace: true }],
                      initialValue: drawer.form.custName
                    }
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入客户名"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="发票类型">
                <a-radio-group 
                  v-decorator="[
                    'invoiceType',
                    {
                      rules: [{ required: true, message: '请选择发票类型' }],
                      initialValue: drawer.form.invoiceType
                    }
                  ]"
                  size="small" >
                  <a-radio v-for="item in pageData.invoiceTypeList" :value="item.code" :key="item.code">{{item.value}}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="所属商家">
                <a-select
                  placeholder="请选择所属商家"
                  v-decorator="[
                    'sapVendorId',
                    {
                      rules: [{ required: true, message: '请选择所属商家' }],
                      initialValue: drawer.form.sapVendorId
                    }
                  ]"
                  size="small" >
                  <a-select-option v-for="item in pageData.sapVenderList" :value="item.code" :key="item.code">{{item.value}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="商户公司名称">
                <a-input
                  v-decorator="[
                    'custCompanyName',
                    {
                      rules: [{ required: true, message: '请输入商户公司名称', whitespace: true }],
                      initialValue: drawer.form.custCompanyName
                    },
                  ]"
                  size="small"
                  placeholder="请输入商户公司名称"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="公司名称">
                <a-input
                  v-decorator="[
                    'compayName',
                    {
                      rules: [{ required: false, message: '请输入公司名称', whitespace: true }],
                      initialValue: drawer.form.compayName
                    },
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入公司名称"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="税号">
                <a-input
                  v-decorator="[
                    'custTaxNo',
                    {
                      rules: [{ required: true, message: '请输入税号', whitespace: true }],
                      initialValue: drawer.form.custTaxNo
                    },
                  ]"
                  size="small"
                  placeholder="请输入税号"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="公司地址">
                <a-input
                  v-decorator="[
                    'address',
                    {
                      rules: [{ required: false, message: '请输入公司地址', whitespace: true }],
                      initialValue: drawer.form.address
                    },
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入公司地址"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="公司地址">
                <a-input
                  v-decorator="[
                    'custAdress',
                    {
                      rules: [{ required: true, message: '请输入公司地址', whitespace: true }],
                      initialValue: drawer.form.custAdress
                    },
                  ]"
                  size="small"
                  placeholder="请输入公司地址"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="公司电话">
                <a-input
                  v-decorator="[
                    'phone',
                    {
                      rules: [{ required: false, message: '请输入公司电话', whitespace: true }],
                      initialValue: drawer.form.phone
                    },
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入公司电话"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="邮箱">
                <a-input
                  v-decorator="[
                    'emailAddress',
                    {
                      rules: [{ required: true, message: '请输入邮箱', whitespace: true }],
                      initialValue: drawer.form.emailAddress
                    },
                  ]"
                  size="small"
                  placeholder="请输入邮箱"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="银行账号">
                <a-input
                  v-decorator="[
                    'bankAccount',
                    {
                      rules: [{ required: false, message: '请输入银行账号', whitespace: true }],
                      initialValue: drawer.form.bankAccount
                    },
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入银行账号"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="电话">
                <a-input
                  v-decorator="[
                    'custPhone',
                    {
                      rules: [{ required: true, message: '请输入电话', whitespace: true }],
                      initialValue: drawer.form.custPhone
                    },
                  ]"
                  size="small"
                  placeholder="请输入电话"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="开户行">
                <a-input
                  v-decorator="[
                    'wmmerOpenBank',
                    {
                      rules: [{ required: false, message: '请输入开户行', whitespace: true }],
                      initialValue: drawer.form.wmmerOpenBank
                    },
                  ]"
                  size="small"
                  disabled
                  placeholder="请输入开户行"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="银行账号">
                <a-input
                  v-decorator="[
                    'merBankNo',
                    {
                      rules: [{ required: true, message: '请输入银行账号', whitespace: true }],
                      initialValue: drawer.form.merBankNo
                    },
                  ]"
                  size="small"
                  placeholder="请输入银行账号"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="开户行">
                <a-input
                  v-decorator="[
                    'merOpenBank',
                    {
                      rules: [{ required: true, message: '请输入开户行', whitespace: true }],
                      initialValue: drawer.form.merOpenBank
                    },
                  ]"
                  size="small"
                  placeholder="请输入开户行"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item label="备注">
                <a-textarea
                  v-decorator="[
                    'remark',
                    {
                      rules: [{ required: false, message: '请输入备注', whitespace: true }],
                      initialValue: drawer.form.remark
                    },
                  ]"
                  size="small"
                  :rows="4"
                  placeholder="请输入备注"
                />
              </a-form-item>
            </a-col>
          </a-row>
          
        </a-form>
        <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="drawerClose">取消</a-button>
          <a-button type="primary" @click="drawerFormSubmit">开票</a-button>
        </div>
      </a-drawer>

      <a-modal 
        v-model="modal.visible"
        width="50%"
        :footer="null"
        @cancel="modalCancel">
        <a-result
          status="success"
          :title="modal.result"
          :sub-title="`尊敬的客户您好：您于${modal.currentDate}开具电子发票，发票信息如下。`"
        >
          <template>
            <a-table 
              size="middle" 
              :columns="modal.columns"
              :data-source="modal.list" 
              :pagination="false">
              <template slot="action" slot-scope="text, record">
                <a href="javascript:;" @click="invoiceUrlOpen(record)" v-if="record.invoiceUrl">下载发票</a>
              </template>
            </a-table>
          </template>
        </a-result>
      </a-modal>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NP from 'number-precision'
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_QUERYCOMMUNITYCUSTLIST, INVOICE_QUERYSGINVOICE, INVOICE_QUERYCOMPANYINFO, POST_PAYBILL_QUERYPAYSTATEENUM, INVOICE_INVOICECOMMIT } from '../../lib/axios/apilist'

export default {
//这里必须 使用一个方法返回给data
  data: function () {
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };

    let condition = {
      communityId: undefined, // 所在的项目ID
      custId: undefined, // 客户号
      mchNo: undefined, // 门店号
      mchName: undefined, // 门店名
      billingCycle: undefined, // 应收账期
      contractCode: undefined, // 合同编号
    }
    let tableObj = {
      tableLoading: false,
      selectedRowKeys: [],
      list: [],
      scroll: {
        x: 1000,
        y: 'auto'
      },
      columns: [
        { dataIndex: 'custId', title: '客户号', },
        { dataIndex: 'custName', title: '客户名称', },
        { dataIndex: 'contrantId', title: '合同号', },
        { dataIndex: 'mchNo', title: '门店号', },
        { dataIndex: 'mchName', title: '门店名', },
        { dataIndex: 'incomeStatusName', title: '收入状态', },
        { dataIndex: 'invoiceItem', title: '发票项目', },
        { dataIndex: 'projectAmount', title: '本金合计', },
        { dataIndex: 'penalAmount', title: '违约金', },
        { dataIndex: 'deliveryTime', title: '账单月份', },
        { dataIndex: 'starBillTime', title: '账单开始时间', },
        { dataIndex: 'endBillTime', title: '账单结束时间', },
      ]
    }
    let pageData = {
      billingCycle: undefined,
      custList: [],
      invoiceTypeList: [],
      sapVenderList: [],
    }
    let drawer = {
      visible: false,
      placement: 'bottom',
      height: '90%',
      form: {
        merId: undefined, // 商户信息id
        custCompanyName: undefined, // 商户公司名称
        custTaxNo: undefined, // 商户税号
        custAdress: undefined, // 商户地址
        custPhone: undefined, // 商户手机号
        merBankNo: undefined, // 商户银行账号
        merOpenBank: undefined, // 商户开户行
        emailAddress: undefined, // 商户邮箱地址
        remark: undefined, // 商户备注
        id: undefined, // 主体公司id
        compayName: undefined, // 主体公司名称
        address: undefined, // 主体公司地址
        phone: undefined, // 主体公司电话
        bankAccount: undefined, // bankAccount
      }
    }
    let modal = {
      visible: false,
      result: '开具成功',
      currentDate: moment().format('YYYY年MM月DD日'),
      columns: [
        { dataIndex: 'invoiceOrderNo', title: '发票订单号', },
        { dataIndex: 'invoiceDate', title: '开票日期', },
        { dataIndex: 'invoiceCode', title: '发票代码', },
        { dataIndex: 'invoiceNo', title: '发票号码', },
        { dataIndex: 'sellerName', title: '销方公司名称', },
        { dataIndex: 'custCompanyName', title: '购方公司名称', },
        { dataIndex: 'invoiceAmount', title: '发票金额', },
        { dataIndex: 'message', title: '开票结果描述', },
        { dataIndex: 'action', title: '发票下载地址', width: 100, fixed: 'right', scopedSlots: { customRender: 'action' }, },
      ],
      list: []
    }
    return {
      modal,
      drawer,
      pageData,
      pagination,
      condition,
      tableObj,
    }
  },
  beforeCreate () {
    this.drawerForm = this.$form.createForm(this);
  },
  mounted() {
    this.$nextTick(function () {
      
    });
    this.initFunc()
    
  },
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    
  },
  watch: {
  },
  computed: {
    hasSelected() {
      return this.tableObj.selectedRowKeys.length > 0;
    },
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    billingCycleChange(date, dateString) {
      if (dateString) {
        this.condition.billingCycle = dateString;
        this.pageData.billingCycle = dateString;

      } else {
        this.pageData.billingCycle = undefined;
        this.condition.billingCycle = undefined;
      }
    },
    communityChange(value){
      let find = this.pageData.custList.find(item=>{
        return item.communityId === value
      })
      if(find){
        this.condition.communityId = find.communityId // 所在的项目ID
        this.condition.custId = find.custId // 客户号
        this.condition.mchNo = find.communityCode // 门店号
        this.condition.mchName = find.communityName // 门店名
      }
    },
    initFunc(){
      //搜索地址
      let url = POST_PAYBILL_QUERYCOMMUNITYCUSTLIST;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.pageData.custList = res.data
          if(res.data.length>0){
            this.communityChange(res.data[0].communityId)
            this.search()
          }
          
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {}
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    queryPayStateEnum(){
      let url = POST_PAYBILL_QUERYPAYSTATEENUM;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.pageData.invoiceTypeList = res.data.invoiceTypeList
          this.pageData.sapVenderList = res.data.sapVenderList
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
      }
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
      let searchParam = {
        ...this.condition
      }
      // 开启加载效果
      this.tableObj.tableLoading = true;
      //浅复制
      let requestParam = Object.assign({}, searchParam, param);
      

      // 清空table数据
      this.tableObj.list = [];

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;
        if (res.code === "0000") {
          this.tableObj.list = res.data
          //调整TABLE样式
          that.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            that.tableObj.scroll.x = 200 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = INVOICE_QUERYSGINVOICE;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    resetEvt() {
      this.condition = {
        communityId: undefined, // 所在的项目ID
        custId: undefined, // 客户号
        mchNo: undefined, // 门店号
        mchName: undefined, // 门店名
        billingCycle: undefined, // 应收账期
        contractCode: undefined, // 合同编号
      }
      this.pageData.billingCycle = undefined;
    },
    onSelectChange(selectedRowKeys) {
      this.tableObj.selectedRowKeys = selectedRowKeys;
    },
    drawerOpen(){
      let reduceList = this.tableObj.list.reduce((list, item ,index)=>{
        let some = this.tableObj.selectedRowKeys.some(el=>{
          return parseFloat(el) === index
        })
        if(some){
          list.push(item)
        }
        return list
      },[])
      let wmItemCode = undefined,
          contrantId = undefined,
          every = false
      // wmItemCode contrantId
      reduceList.forEach(item=>{
        if(wmItemCode === undefined || contrantId === undefined){
          wmItemCode = item.wmItemCode
          contrantId = item.contrantId
        }else{
          if(wmItemCode !== item.wmItemCode || contrantId !== item.contrantId){
            every = true
          }
        }
      })
      if(every){
        this.$message.warning('勾选数据的合同号和发票项目必须相同！');
        return false
      }
      this.queryPayStateEnum()

      let successFunc = (res) => {
        if (res.code === "0000") {
          debugger
          this.drawer.form = {
            ...res.data,
            communityId: this.condition.communityId,
            custId: reduceList[0].custId,
            custName: reduceList[0].custName,
          }
          this.drawer.visible = true
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        mchNo: reduceList[0].mchNo,
        communityId: this.condition.communityId,
        custId: reduceList[0].custId,
      }
      let url = INVOICE_QUERYCOMPANYINFO;
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    drawerFormSubmit(){
      this.drawerForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          values.list = this.tableObj.list.reduce((list, item ,index)=>{
            let some = this.tableObj.selectedRowKeys.some(el=>{
              return parseFloat(el) === index
            })
            if(some){
              list.push(item)
            }
            return list
          },[])
          let successFunc = (res) => {
            if (res.code === "0000") {
              this.drawerClose()
              this.modal.visible = true
              this.modal.list = res.data
              this.modal.result = res.result
            } else {
              this.$error({
                title: '提示',
                content: res.result,
              });
            }
          };
          let errorFunc = (res) => {
            this.$error({
              title: '提示',
              content: res.result,
            });
          };
          let requestParam = {
            ...values
          }
          let url = INVOICE_INVOICECOMMIT;
          ajax.fetch(url, requestParam, successFunc, errorFunc)
        }
      });
    },
    drawerClose(){
      this.drawer = {
        visible: false,
        placement: 'bottom',
        height: '90%',
        form: {
          merId: undefined, // 商户信息id
          custCompanyName: undefined, // 商户公司名称
          custTaxNo: undefined, // 商户税号
          custAdress: undefined, // 商户地址
          custPhone: undefined, // 商户手机号
          merBankNo: undefined, // 商户银行账号
          merOpenBank: undefined, // 商户开户行
          emailAddress: undefined, // 商户邮箱地址
          remark: undefined, // 商户备注
          id: undefined, // 主体公司id
          compayName: undefined, // 主体公司名称
          address: undefined, // 主体公司地址
          phone: undefined, // 主体公司电话
          bankAccount: undefined, // bankAccount
          list: []
        }
      }
    },
    modalCancel(){
      this.$router.push({
        path:this.$route.fullPath, // 获取当前连接，重新跳转
        query:{
          _time:new Date().getTime()/1000  // 时间戳，刷新当前router
        }
      })
      window.location.reload()
    },
    invoiceUrlOpen(rowData){
      window.open(rowData.invoiceUrl)
    }

  }
}
</script>

<style scoped>
.space-margin-bottom{
  margin-bottom: 10px;
}

</style>